import { formatAmount, parseAmount } from 'helpers';
import { InputProps, isInt, NumberInput } from 'libs/ui';

import { FieldType } from '../types';
import { useField } from '../useField';

export interface TextFieldProps
  extends FieldType,
    Omit<InputProps, 'name' | 'onChange' | 'onChangeText' | 'value'> {}

/**
 * Amount field.
 */
export const QuantityField = ({
  name,
  allowSubmit,
  readOnly,
  ...props
}: TextFieldProps) => {
  const { field, helpers, inputProps } = useField<number | undefined>(name);

  const isError = inputProps.error;
  const { helperText } = inputProps;

  return (
    <NumberInput
      {...props}
      fullWidth
      checkNumber={isInt}
      error={isError}
      format={formatAmount}
      helperText={helperText}
      name={name}
      parse={parseAmount}
      readOnly={readOnly || inputProps.readOnly}
      showCopyButton={inputProps.showCopyButton}
      value={field.value}
      onBlur={field.onBlur(name)}
      onChange={() => {
        if (isError) {
          helpers.setError(undefined);
        }
      }}
      onChangeText={(v) => {
        helpers.setValue(v);
      }}
    />
  );
};
